const e=Object.freeze({isVisible:!1,title:""});export{e as INITIAL_DIALOG_STATE};
//# sourceMappingURL=SummaryFeedbackConfigurationRankAndNotes.constants.js.map
